package devxertech.com.pages.services.chatbotDevelopment.chatbotStrategy

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import devxertech.com.pages.dashboard.softwareDevelopmentSection.SoftwareColumn
import devxertech.com.theme.SitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px

@Composable
fun ChatBotStrategy(breakpoint: Breakpoint, sitePalette: SitePalette){
    Column (modifier = Modifier.fillMaxWidth()){
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .backgroundColor(sitePalette.softwareSectionBackground.rgb),
            contentAlignment = Alignment.Center
        ) {
            Column(
                modifier = Modifier.fillMaxWidth()
                    .padding( top= 40.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SpanText(
                    text = "Get Started Today",
                    modifier = Modifier
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(18.px)
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .fontWeight(FontWeight.Medium)
                        .lineHeight(15.4.px)
                        .textTransform(TextTransform.Uppercase)
                        .padding(bottom = 10.px)
                )
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    val rowTextModifier = Modifier
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
                        .fontWeight(FontWeight.ExtraBold)
                        .textTransform(TextTransform.Uppercase)
                    Row(
                        modifier = Modifier.flexWrap(FlexWrap.Wrap),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SpanText(
                            text = "Successful ",
                            modifier = rowTextModifier.color(sitePalette.commonSecondaryButtonColor.rgb)
                        )
                        SpanText(
                            text = "Strategy ",
                            modifier = rowTextModifier.color(sitePalette.primary.rgb)
                        )
                        SpanText(
                            text = "with",
                            modifier = rowTextModifier.color(sitePalette.primary.rgb)
                        )
                        if (breakpoint >= Breakpoint.MD) {
                            SpanText(
                                text = " proven Result",
                                modifier = rowTextModifier.color(sitePalette.primary.rgb)
                            )
                        }
                    }
                    if (breakpoint < Breakpoint.MD){
                        SpanText(
                            text = "  proven Result",
                            modifier = Modifier
                                .fontFamily(Constants.FONT_FAMILY)
                                .fontSize(20.px)
                                .color(sitePalette.primary.rgb)
                                .fontWeight(FontWeight.ExtraBold)
                        )
                    }
                }
// Row for columns
                if(window.screen.width in 960..1439){
                    Row(
                        modifier = Modifier
                            .fillMaxWidth().margin(leftRight = 30.px, top = 100.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.SpaceEvenly,
                    ) {
                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.chatbot_ContactUs,
                            number = "01", title = "Contact Us",
                            description = "Have questions or need assistance? Our team is here to" +
                                    " help!For inquiries, support, or feedback, we respond quickly " +
                                    "and are happy to assist. Feel free to send us a message, " +
                                    "and we’ll get back to you as soon as possible.",
                            downArrow = true)
                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.chatbot_Consult,
                            number = "02", title = "Get a consultation",
                            description = "Schedule a call with our team for " +
                                    "a consultation and assess the feasibility of" +
                                    "your project concept. Let’s discuss and explore the possibilities together",
                            downArrow = true
                        )
                    }
                    Row(
                        modifier = Modifier
                            .fillMaxWidth().margin(leftRight = 30.px, top = 10.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.SpaceEvenly,
                    ) {
                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.chatbot_Cost,
                            number = "03",
                            title = "Get a cost estimate",
                            description = "Receive a cost estimate by sharing your project details." +
                                    " After reviewing your requirements, we’ll present a proposal with a budget and timeline.",
                        )
                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.deployment,
                            number = "04", title = "Project Kickoff",
                            description ="After project approval, we form a skilled and diverse" +
                                    " team for the project kickoff. This team collaborates to initiate and successfully launch your project."
                        )
                    }

                }
                else{
                    Row(
                        modifier = Modifier
                            .fillMaxWidth().margin(leftRight = 30.px, top = 100.px)
                            .flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.Center,
                    ) {
                        val imagelineModifier = Modifier
                            .width(120.px)
                            .border(1.px)
                            .margin(left = (-20).px, top = 50.px)

                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.chatbot_ContactUs,
                            number = "01", title = "Contact Us",
                            description = "Have questions or need assistance? Our team is here to" +
                                    " help!For inquiries, support, or feedback, we respond quickly" +
                                    " and are happy to assist. Feel free to send us a message, " +
                                    "and we’ll get back to you as soon as possible.",
                            downArrow = breakpoint <= Breakpoint.LG,

                            )
                        if(breakpoint > Breakpoint.LG){
                            Image(src = Res.Image.development_arrow, description = "", modifier = imagelineModifier)
                        }
                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.chatbot_Consult,
                            number = "02", title = "Get a consultation",
                            description = "Schedule a call with our team for " +
                                    "a consultation and assess the feasibility of" +
                                    "your project concept. Let’s discuss and explore the possibilities together",
                            downArrow = breakpoint <= Breakpoint.LG,
                            minusLeft = true
                        )
                        if (breakpoint > Breakpoint.LG){
                            Image(src = Res.Image.development_arrow, description = "", modifier = imagelineModifier)
                        }

                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.chatbot_Cost,
                            number = "03",
                            title = "Get a cost estimate",
                            description = "Receive a cost estimate by sharing your project details." +
                                    " After reviewing your requirements, we’ll present a proposal with a budget and timeline.",
                            downArrow = breakpoint < Breakpoint.MD,
                            minusLeft = true
                        )
                        if (breakpoint > Breakpoint.LG){
                            Image(src = Res.Image.development_arrow, description = "", modifier = imagelineModifier)
                        }
                        SoftwareColumn(breakpoint = breakpoint, image = Res.Image.deployment,
                            number = "04", title = "Project Kickoff",
                            description = "After project approval, we form a skilled and diverse" +
                                    "team for the project kickoff. This team collaborates to initiate and successfully launch your project.",
                            minusLeft = true

                        )
                    }
                }

            }
        }
    }
}
